import React, { useReducer } from 'react'
import CommonContext from './commonContext'
import CommonReducer from './commonReducer'
import { apiCall } from '@/product/common/api'
import { response } from '@/product/context/common'

import { COMMON_VALUES, RESPONSE_STATUS, CLEAR_RESPONSE } from './commonTypes'

const CommonState = (props) => {
    const initialState = {
        allCategory: [],
        allLocations: [],
        allCondition: [],
        allNotifications: [],
        allConfigurationVariables: {},
        allBidIncrements: [],
        alldata_all_dropdown: [],
        allUi: [],
        allfaq: [],
        responseStatus: null,
        allTaxCodeList: [],
        allHomeBanner: [],
        alldisapprovalReason: [],
        allMaintanenceData: {},
    }

    const [state, dispatch] = useReducer(CommonReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getGlobalVariable = async (type) => {
        const [res] = await Promise.all([
            apiCall('post', 'getDefault', {}, '', '', true),
        ])
        if (res.data.status === 'success') {
            dispatch({
                type: COMMON_VALUES,
                payload: {
                    allCategory:
                        res.data.data.responseData.tableValues.allcategorytypes.filter(
                            (value) => value.active != 2
                        ),
                    allNotifications:
                        res.data.data.responseData.tableValues
                            .allall_notifications,
                    allConfigurationVariables:
                        res.data.data.responseData.variables,
                    allLocations:
                        res.data.data.responseData.tableValues.alllocations.filter(
                            (value) => value.active != 2
                        ),
                    allCondition:
                        res.data.data.responseData.tableValues.allconditiontypes.filter(
                            (value) => value.active != 2
                        ),
                    allMaintanenceData:
                        res.data.data.responseData.maintanenceData,
                    allfaq: res.data.data.responseData.tableValues.allfaq,
                    alldata_all_dropdown: res.data.data.responseData.tableValues
                        .alldata_all_dropdown
                        ? res.data.data.responseData.tableValues.alldata_all_dropdown.filter(
                              (value) => value.active != 2
                          )
                        : [],
                    allUi: res.data.data.responseData.tableValues
                        .allui_settings,
                    allBidIncrements:
                        res.data.data.responseData.allBidIncrements,
                    bidIncrementDefault:
                        res.data.data.responseData.bidIncrementDefault,
                    allTaxCodeList:
                        res.data.data.responseData.tableValues.alltax_code_list,
                    foreignCurrencyExchange:
                        res.data.data.responseData.tableValues
                            .foreign_currency_exchange || [],
                    allHomeBanner:
                        res.data.data.responseData.tableValues.allhome_banner,
                    alldisapprovalReason:
                        res.data.data.responseData.tableValues
                            .alldisapproval_reason,
                },
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })
    return (
        <CommonContext.Provider
            value={{
                allCategory: state.allCategory,
                allNotifications: state.allNotifications,
                allLocations: state.allLocations,
                allCondition: state.allCondition,
                allBidIncrements: state.allBidIncrements,
                allUi: state.allUi,
                allfaq: state.allfaq,
                allConfigurationVariables: state.allConfigurationVariables,
                alldata_all_dropdown: state.alldata_all_dropdown,
                responseStatus: state.responseStatus,
                allTaxCodeList: state.allTaxCodeList,
                allHomeBanner: state.allHomeBanner,
                alldisapprovalReason: state.alldisapprovalReason,
                allMaintanenceData: state.allMaintanenceData,
                getGlobalVariable,
                clearResponse,
            }}
        >
            {props.children}
        </CommonContext.Provider>
    )
}

export default CommonState
